module.exports = __webpack_public_path__ + "static/media/400412_02.6528143d.png";